import type { ReactNode } from "react";
import { cn } from "~/foundation/utils/cn";
import { formatShortcut } from "~/foundation/utils/platform";

export interface KbdProps {
  /** Declarative shortcut, e.g. ["Meta", "k"] — rendered per platform. */
  keys?: readonly string[];
  /** `inverted` for chips sitting on the tooltip surface, which is the inverse of the page. */
  tone?: "default" | "inverted";
  children?: ReactNode;
  className?: string;
}

const BASE =
  "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-[3px] px-1 " +
  "font-mono text-[11px] leading-none";

const TONE = {
  default: "border border-input-border bg-bg-secondary text-text-tertiary",
  inverted: "border border-tooltip-text/25 text-tooltip-text opacity-80",
} as const;

export function Kbd({ keys, tone = "default", children, className }: KbdProps) {
  const chip = cn(BASE, TONE[tone], className);

  if (keys?.length) {
    return (
      <span className="inline-flex items-center gap-0.5">
        {formatShortcut(keys).map((key) => (
          <kbd key={key} className={chip}>
            {key}
          </kbd>
        ))}
      </span>
    );
  }
  return <kbd className={chip}>{children}</kbd>;
}
